import { Box, Flex, Text } from '@chakra-ui/react';
import { DropdownMenuProps } from '~/components/AutocompleteDropdown/types';

export const DropdownMenu: React.FC<DropdownMenuProps> = ({
  selectedValue,
  options,
  onSelect,
}) => (
  <Box
    data-testid="dropdown"
    overflow="auto"
    maxHeight="300px"
    backgroundColor="white"
    boxShadow="menu"
    borderRadius={8}
    padding={4}
  >
    <Box overflowY="auto">
      {options.map((option) => (
        <Flex
          key={option.label}
          alignItems="center"
          gap={2}
          padding={2}
          borderRadius={4}
          height={8}
          backgroundColor={
            option.value === selectedValue ? 'primary.50' : 'none'
          }
          _hover={{
            cursor: 'pointer',
            backgroundColor: 'primary.50',
          }}
          _active={{ backgroundColor: 'primary.50' }}
          _focus={{ backgroundColor: 'primary.100' }}
          _focusVisible={{ backgroundColor: 'primary.100' }}
          onClick={() => onSelect(option)}
        >
          {option.icon && option.icon}
          <Text
            fontSize="md"
            fontWeight={option.value === selectedValue ? '500' : '400'}
            color="primary.700"
          >
            {option.value}
          </Text>
        </Flex>
      ))}
    </Box>
  </Box>
);
